import React, { useState, useEffect } from "react";
import { Button, Divider, Form, Header } from "semantic-ui-react";
import "../Css/CommentBoard.css";
import { getArticleCommentsList, uploadNewComment } from "../utils/commentFunction";
import { auth } from "../utils/firebase";
import AdminContent from "./AdminContent";
import Comment from "./Comment";
function CommentBoard({ aid }) {
  const [commentList, setCommentList] = useState([]);
  const [isSubmiting, setisSubmiting] = useState([false]);
  const [commentInput, setCommentInput] = useState("");
  const [isBusy, setIsBusy] = useState(true);

  useEffect(() => {
    //抓文章留言
    getArticleCommentsList(aid).then((res) => {
      console.log(res);
      setCommentList(res.docs);
      setIsBusy(false);
    });
  }, []);

  //送出留言
  function handleSubmit(e) {
    if (commentInput == "") return;

    var newComment = {
      aid:aid,
      uid:auth.currentUser.uid,
      photoURL:auth.currentUser.photoURL,
      context: commentInput,
    };

    uploadNewComment(newComment).then(res=>{
      console.log(res);
      console.log("上傳成功");
      //清空輸入內容
      setCommentInput("");

      //加入留言列表
    })
  }

  if (isBusy) {
    return <></>;
  } else
    return (
      <div>
        {/* 輸入留言 */}
        {auth.currentUser ? (
          <form
            className="cb-textarea-container"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(e);
            }}
          >
            <textarea
              className="cb-textarea"
              name="context"
              rows="6"
              value={commentInput}
              onChange={(e) => setCommentInput(e.target.value)}
            ></textarea>
            <Button type="submit" color="black">
              送出
            </Button>
          </form>
        ) : (
          <div>登入才能進行留言</div>
        )}

        <Divider></Divider>

        {/* 其他留言 */}
        {commentList.map((comment) => {
          console.log(comment)
          return <Comment cid={comment.id}></Comment>
        })}
      </div>
    );
}

export default CommentBoard;
